import {Injectable} from '@angular/core';
import {Region} from '../../../../models/region';
import {RestClientService} from '../../api-access/rest-client.service';
import {RegionSearchCriteria} from '../../../../models/region-search-criteria';
import {Observable} from 'rxjs';
import {Retrievable} from '../../../../shared/models/retrievable';
import {Searchable} from '../../../../shared/models/searchable';

/**
 * Servicio para las regiones
 */
@Injectable()
export class RegionRemoteService implements
  Searchable<Region, RegionSearchCriteria>,
  Retrievable<Region, number> {

  /**
   * Devuelve la url de la API
   */
  private URL = '/regions';

  /**
   * Constructor
   * @ignore
   */
  constructor(private restClientService: RestClientService) { }

  /**
   * Devuelve listado de regiones
   * @param criteria
   * @returns
   */
  public search(criteria?: RegionSearchCriteria): Observable<Region[]> {
    return this.restClientService.get(this.URL, criteria);
  }

  /**
   * Devuelve una región
   * @param id
   * @returns
   */
  public get(id: number): Observable<Region> {
    return this.restClientService.get(`${this.URL}/${id}`);
  }
}
